"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var webAApi_1 = require("../../../../api/webAApi");
var ReportPromoCodeTplListCtl = /** @class */ (function (_super) {
    __extends(ReportPromoCodeTplListCtl, _super);
    function ReportPromoCodeTplListCtl(errDialog, controller) {
        var _this = _super.call(this, true) || this;
        _this.dk_promocode_tpl_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promocode_tpl_id; });
        _this.dk_promocode_tpl_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promocode_tpl_title; });
        _this.dk_bonus_state_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_state_code; });
        _this.dk_bonus_state_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_state_title; });
        _this.dk_bonus_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_count; });
        _this.dk_creation_bonus_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.creation_bonus_amount; });
        _this.dk_creation_money_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.creation_money_amount; });
        _this.dk_completition_bonus_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.completition_bonus_amount; });
        _this.dk_completition_money_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.completition_money_amount; });
        _this._errDialog = errDialog;
        _this._controller = controller;
        return _this;
    }
    ReportPromoCodeTplListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total_count: 0,
            app_currency_id: 0,
            app_currency_iso: "",
            app_currency_symbol: "",
            bonus_count: 0,
            total_creation_bonus_amount: 0,
            total_creation_money_amount: 0,
            total_completition_bonus_amount: 0,
            total_completition_money_amount: 0
        };
    };
    ReportPromoCodeTplListCtl.prototype.LoadData = function (dtRange, onDone) {
        var _this = this;
        webAApi_1.ListBrandPromoTplReportByDateRangeGet.exec({
            from_year: dtRange.from_year,
            from_month: dtRange.from_month,
            from_day: dtRange.from_day,
            to_year: dtRange.to_year,
            to_month: dtRange.to_month,
            to_day: dtRange.to_day,
            brands_id_list: dtRange.brands_id_list,
            all_brands: dtRange.all_brands,
            app_currency_id: dtRange.app_currency_id,
            all_bonus_states: dtRange.allBonusStates,
            bonuses_state_list: dtRange.bonus_states
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total_count = resp.total_count;
            _this.DATA.app_currency_id = resp.app_currency_id;
            _this.DATA.app_currency_iso = resp.app_currency_iso;
            _this.DATA.app_currency_symbol = resp.app_currency_symbol;
            _this.DATA.bonus_count = resp.bonus_count;
            _this.DATA.total_creation_bonus_amount = resp.total_creation_bonus_amount;
            _this.DATA.total_creation_money_amount = resp.total_creation_money_amount;
            _this.DATA.total_completition_bonus_amount = resp.total_completition_bonus_amount;
            _this.DATA.total_completition_money_amount = resp.total_completition_money_amount;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    promocode_tpl_id: resp.list[i].promocode_tpl_id,
                    promocode_tpl_title: resp.list[i].promocode_tpl_title,
                    bonus_state_code: resp.list[i].bonus_state_code,
                    bonus_state_title: resp.list[i].bonus_state_title,
                    bonus_count: resp.list[i].bonus_count,
                    creation_bonus_amount: resp.list[i].creation_bonus_amount,
                    creation_money_amount: resp.list[i].creation_money_amount,
                    completition_bonus_amount: resp.list[i].completition_bonus_amount,
                    completition_money_amount: resp.list[i].completition_money_amount,
                    total: false
                });
            }
            _this.DATA.data.push({
                promocode_tpl_id: 0,
                promocode_tpl_title: "ИТОГО",
                bonus_state_code: 0,
                bonus_state_title: "",
                bonus_count: _this.DATA.bonus_count,
                creation_bonus_amount: _this.DATA.total_creation_bonus_amount,
                creation_money_amount: _this.DATA.total_creation_money_amount,
                completition_bonus_amount: _this.DATA.total_completition_bonus_amount,
                completition_money_amount: _this.DATA.total_completition_money_amount,
                total: true
            });
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ReportPromoCodeTplListCtl.prototype.doExportObjectArray = function (dtRange, onDone) {
        var _this = this;
        var _data = [];
        this.LoadData(dtRange, function () {
            for (var i = 0; i < _this.DATA.data.length; i++) {
                _data.push({
                    //bonus_tpl_id: this.DATA.data[i].bonus_tpl_id,
                    promocode_tpl_title: _this.DATA.data[i].promocode_tpl_title,
                    //bonus_state_code: this.DATA.data[i].bonus_state_code,
                    bonus_state_title: _this.DATA.data[i].bonus_state_title,
                    bonus_count: _this.DATA.data[i].bonus_count,
                    creation_bonus_amount: _this.DATA.data[i].creation_bonus_amount,
                    creation_money_amount: _this.DATA.data[i].creation_money_amount,
                    completition_bonus_amount: _this.DATA.data[i].completition_bonus_amount,
                    completition_money_amount: _this.DATA.data[i].completition_money_amount,
                });
            }
            /*_data.push({

                //bonus_tpl_id: 0,
                promocode_tpl_title: "ИТОГО",
                //bonus_state_code : 0,
                bonus_state_title: "",
                bonus_count: this.DATA.bonus_count,
                creation_bonus_amount: this.DATA.total_creation_bonus_amount,
                creation_money_amount: this.DATA.total_creation_money_amount,
                completition_bonus_amount: this.DATA.total_completition_bonus_amount,
                completition_money_amount: this.DATA.total_completition_money_amount,
            })*/
            if (onDone) {
                onDone(_data);
            }
        });
    };
    return ReportPromoCodeTplListCtl;
}(BaseController_1.BaseController));
exports.ReportPromoCodeTplListCtl = ReportPromoCodeTplListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/rep_promocodes/ctl/RepPromoCodesCtl.ts
// module id = 1027
// module chunks = 0